export default "__VITE_ASSET__9cde1e33__"